// extracted by mini-css-extract-plugin
module.exports = {"stickToEnd":"JobsMobileHeader_stickToEnd__H3v3R","textContainer":"JobsMobileHeader_textContainer__rhjD6","title":"JobsMobileHeader_title__H2xGu"};